// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"b6e67851","453":"f5824463","470":"4f55233c"}[chunkId] + ".chunk.js";
};